
import { useStyletron } from 'baseui';

export function IconEdgeDevice({ height, width, color }: any) {
    return (

        <svg width={width || '100%'} height={height || '100%'} version="1.1" x="0px" y="0px" viewBox="0 0 100 100"  >
            <path fill={color} d="M68.2,19.9c-4.8-4.8-11.1-7.4-17.8-7.4c-6.7,0-13.1,2.6-17.8,7.4l3,3c4-4,9.3-6.2,14.9-6.2c5.6,0,10.9,2.2,14.9,6.2  L68.2,19.9z"></path>
            <path fill={color} d="M50.4,3.8c-9.1,0-17.6,3.5-24,9.9l3,3C35,11.1,42.5,8,50.4,8c7.9,0,15.4,3.1,21,8.7l3-3C68,7.3,59.4,3.8,50.4,3.8z"></path>
            <path fill={color} d="M38.2,25.5l3,3c2.5-2.5,5.7-3.8,9.2-3.8c3.5,0,6.8,1.4,9.2,3.8l3-3c-3.3-3.3-7.6-5-12.2-5C45.8,20.5,41.5,22.3,38.2,25.5z"></path>
            <path fill={color} d="M64.4,54.9H52.5V44.4c2.8-0.9,4.9-3.5,4.9-6.7c0-3.9-3.1-7-7-7s-7,3.1-7,7c0,3.1,2.1,5.8,4.9,6.7v10.6H36.4  c-3.7,0-6.7,3-6.7,6.7v27.9c0,3.7,3,6.7,6.7,6.7h27.9c3.7,0,6.7-3,6.7-6.7V61.7C71.1,57.9,68.1,54.9,64.4,54.9z M50.4,85.8  c-5.6,0-10.2-4.6-10.2-10.2s4.6-10.2,10.2-10.2S60.5,70,60.5,75.6S56,85.8,50.4,85.8z"></path>
        </svg>
    );
}
